import React, { ReactNode } from 'react';
import { Box, Button, useTheme } from '@mui/material';

type Props = {
  icon: ReactNode;
  onClick(): void;
  disabled?: boolean;
  walletName: string;
};

export const WalletActionButton: React.FC<Props> = ({
  icon,
  walletName,
  ...rest
}) => {
  const theme = useTheme();
  return (
    <Button
      sx={{
        minWidth: 'auto',
        minHeight: { xs: '56px', sm: '92px' },
        width: '100%',
        padding: { xs: '0 24px 0 12px', sm: '0 10px 0 14px' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '8px',
        border: '1px solid #5663F2',
      }}
      {...rest}
    >
      <Box
        component={'div'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: { xs: '16px', sm: '28px' },
        }}
      >
        <Box
          component={'div'}
          sx={{
            height: 'auto',
            width: '100%',
            minWidth: { xs: '32px', sm: '48px' },
            maxWidth: { xs: '32px', sm: '48px' },
          }}
        >
          {icon}
        </Box>
        <Box
          component={'span'}
          sx={{
            fontSize: { xs: '14px', sm: '20px' },
            fontWeight: 400,
            textTransform: 'capitalize',
            color: theme.palette.text.primary,
          }}
        >
          {walletName}
        </Box>
      </Box>
    </Button>
  );
};
